<div class="kb-cat-manager-container">
  <ngx-spinner name="kb-cat-spinner" bdColor="rgba(0,0,0,0.3)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="color: white">Loading...</p>
  </ngx-spinner>

  <!-- Header -->
  <div class="row align-items-center mb-3">
    <div class="col">
      <h4 class="mb-0">Category Management</h4>
    </div>
    <div class="col-auto">
      <button nbButton ghost size="small" (click)="goBack()">
        <nb-icon icon="arrow-back-outline" pack="eva"></nb-icon> Back to Articles
      </button>
    </div>
  </div>

  <!-- Categories Table -->
  <nb-card>
    <nb-card-body class="p-0">
      <table class="table table-hover mb-0 cat-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Slug</th>
            <th style="width: 90px; text-align: center;">Order</th>
            <th style="width: 160px; text-align: right;">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!loading && categories.length === 0">
            <td colspan="4" class="text-center text-muted py-4">No categories yet. Add one below.</td>
          </tr>

          <tr *ngFor="let cat of categories">
            <!-- Name cell -->
            <td>
              <ng-container *ngIf="editingId === cat._id; else nameDisplay">
                <input nbInput fullWidth [(ngModel)]="editName" size="small" placeholder="Category name" />
              </ng-container>
              <ng-template #nameDisplay>{{ cat.name }}</ng-template>
            </td>

            <!-- Slug (always read-only) -->
            <td class="text-muted slug-cell">{{ cat.slug }}</td>

            <!-- Order cell -->
            <td style="text-align: center;">
              <ng-container *ngIf="editingId === cat._id; else orderDisplay">
                <input nbInput type="number" [(ngModel)]="editOrder" size="small" class="order-input" />
              </ng-container>
              <ng-template #orderDisplay>{{ cat.order ?? 0 }}</ng-template>
            </td>

            <!-- Actions -->
            <td style="text-align: right; white-space: nowrap;">
              <ng-container *ngIf="editingId === cat._id; else viewActions">
                <button nbButton status="success" size="tiny" class="me-1" (click)="saveEdit(cat)">
                  <nb-icon icon="checkmark-outline" pack="eva"></nb-icon> Save
                </button>
                <button nbButton ghost size="tiny" (click)="cancelEdit()">Cancel</button>
              </ng-container>
              <ng-template #viewActions>
                <button nbButton status="basic" size="tiny" class="me-1" (click)="startEdit(cat)" nbTooltip="Edit">
                  <nb-icon icon="edit-2-outline" pack="eva"></nb-icon>
                </button>
                <button nbButton status="danger" size="tiny" (click)="deleteCategory(cat)" nbTooltip="Delete">
                  <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
                </button>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </nb-card-body>
  </nb-card>

  <!-- Add New Category -->
  <nb-card class="mt-3">
    <nb-card-header>
      <h6 class="mb-0">Add New Category</h6>
    </nb-card-header>
    <nb-card-body>
      <div class="row g-2 align-items-end">
        <div class="col-sm-6">
          <label class="form-label form-label-sm">Name <span class="text-danger">*</span></label>
          <input nbInput fullWidth [(ngModel)]="newName" placeholder="e.g. Getting Started" />
        </div>
        <div class="col-sm-3">
          <label class="form-label form-label-sm">Order</label>
          <input nbInput fullWidth type="number" [(ngModel)]="newOrder" placeholder="0" />
        </div>
        <div class="col-sm-3">
          <button nbButton status="primary" fullWidth (click)="addCategory()">
            <nb-icon icon="plus-outline" pack="eva"></nb-icon> Add Category
          </button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</div>
